/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

export const loginUrlRegex = /^\/login(?:[/?#&=].*)?$/
export const passwordResetUrlRegex = /^\/user\/password-reset(?:[/?#&=].*)?$/

export function isPublicRoute(pathname: string): boolean {
    return [loginUrlRegex, passwordResetUrlRegex].some((regex) => regex.test(pathname))
}
